import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { CauseBlocageDossier } from '@logaia_users/logaia-dto';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { map } from 'rxjs';

export const dossierIsLibreGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const snackBar = inject(MatSnackBar);
  const dossierService = inject(DossierService);
  return dossierService.isLibre(+route.params['id']).pipe(
    map((res) => {
      if (!res) {
        return true;
      }
      switch (res.causeBlocage) {
        case CauseBlocageDossier._CLOTURE:
          snackBar.open('Clôture en cours.', 'Ok');
          break;
        default:
          snackBar.open('Ouverture du dossier impossible.', 'Ok');
          break;
      }
      return false;
    }),
  );
};
